import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { APPLY_URL } from '../../mock';

export const EditorialNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const onLight = location.pathname === '/organizations';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const textBase = onLight ? 'text-[#141416]' : 'text-[#f4efe6]';

  let bgBase;
  if (!scrolled) {
    bgBase = 'bg-transparent';
  } else if (onLight) {
    bgBase = 'bg-[#f4efe6]/90 backdrop-blur-md border-b border-[#141416]/10';
  } else {
    bgBase = 'bg-[#141416]/90 backdrop-blur-md border-b border-white/5';
  }

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgBase}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_driven-12week/artifacts/6khqy6w1_IMG_6901.png"
            alt="CT3"
            className="w-9 h-9 object-contain"
            style={{ mixBlendMode: onLight ? 'normal' : 'screen' }}
          />
          <span className={`font-editorial text-lg tracking-tight ${textBase}`}>CT3</span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          <Link
            to="/organizations"
            className={`font-sans-clean text-sm tracking-wide ${textBase} hover:text-[#c6a04a] transition-colors`}
          >
            For Organizations
          </Link>
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-sans-clean text-sm tracking-wide bg-[#c6a04a] hover:bg-[#d9be7e] text-[#141416] px-5 py-2.5 transition-colors"
          >
            Apply
          </a>
        </div>

        <button
          className={`md:hidden ${textBase}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div className={`md:hidden ${onLight ? 'bg-[#f4efe6]' : 'bg-[#141416]'} border-t ${onLight ? 'border-[#141416]/10' : 'border-white/5'}`}>
          <div className="px-6 py-6 flex flex-col gap-5">
            <Link
              to="/organizations"
              onClick={() => setMobileOpen(false)}
              className={`font-sans-clean text-base ${textBase}`}
            >
              For Organizations
            </Link>
            <a
              href={APPLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans-clean text-sm bg-[#c6a04a] text-[#141416] px-5 py-3 text-center"
            >
              Apply — 1:1 Coaching
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
